import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetTeamAssignRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}AcceptanceManagement/GetTeamAssign`,
	params: { userId }
});

export const GetTeamAssignDetailsRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}AcceptanceManagement/GetTeamAssignDetails`,
	params: { userId }
});

export const SaveTeamAssignRequest = (allocationUpdate) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}AcceptanceManagement/SaveTeamAssign`,
	data: allocationUpdate
});

export const ResetTeamAssignRequest = (userId, id) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}AcceptanceManagement/ResetTeamAssign`,
	params: { userId, id }
});
